import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoCard.css';

const VideoCard = ({ video }) => {
  const { t } = useTranslation();

  const getYouTubeEmbedUrl = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = (match && match[2].length === 11) ? match[2] : null;
    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
  };

  const embedUrl = getYouTubeEmbedUrl(video.url);
  const thumbnailUrl = embedUrl 
    ? `https://img.youtube.com/vi/${embedUrl.split('/').pop()}/maxresdefault.jpg`
    : null;

  return (
    <div className="video-card">
      {embedUrl ? (
        <div className="video-embed">
          <iframe
            src={embedUrl}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      ) : (
        <div className="video-placeholder">
          <a 
            href={video.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="video-link"
          >
            {thumbnailUrl && (
              <img src={thumbnailUrl} alt={video.title} />
            )}
            <div className="video-overlay">
              <span className="play-icon">▶</span>
              <span>{t('videos.watchOnYouTube')}</span>
            </div>
          </a>
        </div>
      )}
      {video.title && (
        <div className="video-info">
          <h3 className="video-title">{video.title}</h3>
        </div>
      )}
    </div>
  );
};

export default VideoCard;

